import { ClientPageType, DeliveryClientPageType, ROUTES } from '@/constants'
import AppointmentConfirm from '@/views/Delivery/Appointment/appointmentConfirmPage.vue'
import Appointment from '@/views/Delivery/Appointment/appointmentPage.vue'
import MultiTracking from '@/views/Delivery/MultiTracking/MultiTracking.vue'
import Survey from '@/views/Delivery/Survey/Survey.vue'
import SurveyConfirmation from '@/views/Delivery/SurveyConfirmation/SurveyConfimation.vue'
import Tracking from '@/views/Delivery/Tracking/Tracking.vue'
import DrivePickup from '@/views/Drive/Pickup/pickup.vue'
import DriveSignal from '@/views/Drive/Signal/signal.vue'
import DriveSuccess from '@/views/Drive/Success/success.vue'
import DriveSurvey from '@/views/Drive/Survey/Survey.vue'
import DriveSurveyConfirmation from '@/views/Drive/SurveyConfirmation/SurveyConfimation.vue'
import DriveTracking from '@/views/Drive/Tracking/Tracking.vue'
import NotFound from '@/views/Fallback/NotFound.vue'
import LockerPickupPointInfos from '@/views/Locker/LockerPickupPointInfos/LockerPickupPointInfos.vue'
import LockerSurvey from '@/views/Locker/Survey/Survey.vue'
import LockerSurveyConfirmation from '@/views/Locker/SurveyConfirmation/SurveyConfimation.vue'
import LockerTracking from '@/views/Locker/Tracking/Tracking.vue'

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/t/:accessToken',
      name: ClientPageType.DELIVERY.TRACKING,
      component: Tracking,
    },
    {
      path: '/a/:accessToken',
      name: DeliveryClientPageType.APPOINTMENT,
      component: Appointment,
    },
    {
      path: '/a/:accessToken/confirm',
      name: DeliveryClientPageType.APPOINTMENT_CONFIRM,
      component: AppointmentConfirm,
    },
    {
      path: '/s/:accessToken/confirmation',
      name: ClientPageType.DELIVERY.CONFIRMATION,
      component: SurveyConfirmation,
    },
    {
      path: '/s/:accessToken',
      name: ClientPageType.DELIVERY.SURVEY,
      component: Survey,
    },
    {
      path: '/m/:accessToken',
      name: ClientPageType.DELIVERY.MULTI_TRACKING,
      component: MultiTracking,
    },
    {
      path: '/p/:id',
      name: ClientPageType.COLLECT.DRIVE_SLOT,
      component: DrivePickup,
    },
    {
      path: '/dt/:id',
      name: ClientPageType.COLLECT.DRIVE_TRACKING,
      component: DriveTracking,
    },
    {
      path: '/ds/:id',
      name: ClientPageType.COLLECT.REPORT_PRESENCE_AT_DRIVE,
      component: DriveSignal,
    },
    {
      path: '/dsv/:id/confirmation',
      name: ClientPageType.COLLECT.DRIVE_CONFIRMATION,
      component: DriveSurveyConfirmation,
    },
    {
      path: '/dsv/:id',
      name: ClientPageType.COLLECT.DRIVE_SURVEY,
      component: DriveSurvey,
    },
    {
      path: '/dsu/:id',
      name: ClientPageType.COLLECT.REPORT_PRESENCE_AT_DRIVE_SUCCESS,
      component: DriveSuccess,
    },
    {
      path: '/lt/:id',
      name: ClientPageType.LOCKER.LOCKER_TRACKING,
      component: LockerTracking,
    },
    {
      path: '/ls/:id',
      name: ClientPageType.LOCKER.LOCKER_SURVEY,
      component: LockerSurvey,
    },
    {
      path: '/ls/:id/confirmation',
      name: ClientPageType.LOCKER.LOCKER_CONFIRMATION,
      component: LockerSurveyConfirmation,
    },
    {
      path: '/li/:id',
      name: ClientPageType.LOCKER.LOCKER_PICKUP_POINT,
      component: LockerPickupPointInfos,
    },
    {
      path: '/not-found',
      name: ROUTES.NOT_FOUND,
      component: NotFound,
    },
    {
      path: '*',
      redirect: '/not-found',
    },
  ],
})

export default router
